import React from "react";
import isArray from "lodash/isArray";
import flattenDeep from "lodash/flattenDeep";
import styled from "styled-components";
import { KeyboardKey } from "components/bootstrap";
import { isMacOS as _isMacOS } from "util/OSUtils";
import SectionComponent from "components/common/Section/SectionComponent";
const ShortcutList = styled.div`
  display: flex;
  flex-direction: column;
`;
const ShortcutListItem = styled.div`
  display: flex;
  gap: 5px;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 3px;
  }
`;
const KeysList = styled.div`
  display: inline-flex;
  gap: 5px;
  justify-content: right;
  height: fit-content;
`;
const KeySeparator = styled.div`
  display: flex;
  align-items: center;
`;
const keyMapper = (key, isMacOS) => {
  const keyMap = {
    mod: isMacOS ? "\u2318" : "Ctrl",
    alt: isMacOS ? "\u2325" : "Alt",
    ctrl: isMacOS ? "\u2303" : "Ctrl",
    meta: isMacOS ? "\u2318" : "Win"
  };
  return keyMap[key] || key;
};
const ShortcutKeys = ({ keys, splitKey, combinationKey, isMacOS }) => {
  const shortcutsArray = isArray(keys) ? keys : [keys];
  const splitShortcutsArray = flattenDeep(shortcutsArray.map((key) => key.split(splitKey)));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, splitShortcutsArray.map((keysStr, keysStrIndex) => {
    const keysArray = keysStr.split(combinationKey);
    const isLastSplit = keysStrIndex === splitShortcutsArray.length - 1;
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: keysStr }, keysArray.map((key, index) => {
      const isLast = index === keysArray.length - 1;
      return /* @__PURE__ */ React.createElement(React.Fragment, { key }, /* @__PURE__ */ React.createElement(KeyboardKey, null, keyMapper(key, isMacOS)), !isLast && /* @__PURE__ */ React.createElement(KeySeparator, null, combinationKey));
    }), !isLastSplit && /* @__PURE__ */ React.createElement(KeySeparator, null, "or"));
  }));
};
const Key = ({ description, keys, combinationKey, splitKey, isMacOS }) => /* @__PURE__ */ React.createElement(ShortcutListItem, null, description, /* @__PURE__ */ React.createElement(KeysList, null, /* @__PURE__ */ React.createElement(ShortcutKeys, { keys, combinationKey, splitKey, isMacOS })));
const HotkeyCollectionSection = ({ title, description, sectionActions }) => {
  const isMacOS = _isMacOS();
  return /* @__PURE__ */ React.createElement(SectionComponent, { title }, /* @__PURE__ */ React.createElement("p", { className: "description" }, description), /* @__PURE__ */ React.createElement(ShortcutList, null, sectionActions.map(({ keyDescription, keys, combinationKey, splitKey, reactKey }) => /* @__PURE__ */ React.createElement(
    Key,
    {
      description: keyDescription,
      keys,
      combinationKey,
      splitKey,
      isMacOS,
      key: reactKey
    }
  ))));
};
export default HotkeyCollectionSection;
